import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../store/AuthContext';
import { paths } from '../../routes/paths';
import { resolveOnboardingPath } from '../../lib/onboardingStepPaths';
import { Loader } from '../common/Loader';

/**
 * Public routes (landing, sign-in, sign-up) — when the user is already
 * authenticated we send them straight to the right post-login destination.
 */
export function PublicRoute({ children }) {
  const { isLoading, isAuthenticated, isOnboardingComplete, onboardingStep } = useAuth();

  if (isLoading) return <Loader fullscreen />;
  if (!isAuthenticated()) return children || <Outlet />;

  const destination = isOnboardingComplete()
    ? paths.app
    : resolveOnboardingPath(onboardingStep);

  return <Navigate to={destination} replace />;
}
